import { authName } from "../App";

export const downloadEntityTemplate = async (url, fileName = "template") => {
  const token = localStorage.getItem(authName);
  const result = await fetch(url, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "x-access-token": token,
    },
  });

  const contentType = result.headers.get("Content-Type") ?? "";
  if (!result.ok || contentType.includes("application/json")) {
    const errorBody = contentType.includes("application/json")
      ? await result.json()
      : null;
    throw new Error(
      errorBody?.message ?? errorBody?.error ?? "Failed to download template"
    );
  }

  const blob = await result.blob();
  const blobUrl = window.URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = blobUrl;
  const contentDisposition = result.headers.get("Content-Disposition");
  let resolvedFileName = `${fileName}.xlsx`;
  if (contentDisposition) {
    const match = contentDisposition.match(/filename=(.+)/);
    if (match?.[1]) resolvedFileName = match[1];
  }
  anchor.download = resolvedFileName;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  window.URL.revokeObjectURL(blobUrl);
};
